import processes from '@/utils/landing-page/dictionary-processes';
export default {
    name: 'Process',
    data: () => ({
        processes: [],
        nextProcessArrow: `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/next-process.svg`
    }),
    created() {
        this.processes = processes();
    }
};
